export default __webpack_public_path__ + "static/media/img2.6c477ba9.png";